import { jsx } from "react/jsx-runtime";
import TimelineIcon from "@mui/icons-material/Timeline";
import { validateTidalLicense } from "../../base/index.js";
function Timeline(props) {
  return /* @__PURE__ */ jsx(
    TimelineIcon,
    {
      "data-testid": "Timeline",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Timeline",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
Timeline.tidalIconMeta = {
  categories: "miscellaneous",
  name: "Timeline"
};
validateTidalLicense();
export {
  Timeline
};
//# sourceMappingURL=Timeline.js.map
